export default {
  "base": "my-5 divide-y divide-default *:not-last:pb-5"
}